import styled from 'styled-components';

const TitleV2 = styled.div`
  /* Dashboard */
  font-family: Lato;
  font-style: normal;
  font-weight: 900;
  font-size: 40px;
  line-height: 50px;
  margin-bottom:0.5rem;
  /* identical to box height, or 125% */

  color: #26292d;

  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
`;

export default TitleV2;